// src/store/faq/faq.store.ts
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type FaqItem = {
  faqId: number;
  faqType: string;
  faqTtl: string;
  faqCts: string;
  activeYn: boolean;
  faqOrder: number;
};

type FaqQuery = {
  page: number; // UI 1-based
  size: number;
  order: string;
};

type FaqState = FaqQuery & {
  setQuery: (q: Partial<FaqQuery>) => void;
  resetQuery: () => void;
};

const isDev = process.env.NODE_ENV === "development";

export const useFaqStore = create<FaqState>()(
  devtools(
    (set) => ({
      page: 1,
      size: 10,
      order: "faqOrder,asc",

      setQuery: (q) => set((s) => ({ ...s, ...q }), false, "faq/setQuery"),
      resetQuery: () => set({ page: 1, size: 10, order: "faqOrder,asc" }, false, "faq/resetQuery"),
    }),
    { name: "faq-store", enabled: isDev }
  )
);
